import cn from "classnames";
import { InputAdornment, TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { useState } from "react";
import { useTranslate } from "../../../../../hooks/useTranslate";
import IconSupportCommunication from "../../../../../assets/images/icons/support-communication.svg?react";
import IconSearch from "../../../../../assets/images/icons/search.svg?react";
import { isVersionUS } from "../../../../../services/versionService";
import "./NeedSupportBox.css";

const NeedSupportBox = (props) => {
    const { className } = props;
    const { t } = useTranslate();

    const [search, setSearch] = useState("");

    const onFindClick = () => {
        const link = `https://support.kingsinterhigh.co.uk/search/?logicalNames=&q=${encodeURIComponent(search)}`;
        window.open(link, "_blank");
    };

    return (
        <div className={cn("need-support", className)}>
            <div className="need-support__icon">
                <IconSupportCommunication />
            </div>
            <div className="need-support__content">
                <Typography variant="h4" className="need-support__title">
                    {t("home.needSupport")}
                </Typography>
                <div className="w-full flex align-center gap-4 need-support__form">
                    <TextField
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="need-support__input"
                        slotProps={{
                            input: {
                                endAdornment: <InputAdornment position="end"><IconSearch className="need-support__search-icon" /></InputAdornment>,
                            },
                        }}
                    />
                    <Button
                        className={isVersionUS ? "button-primary" : "button-accent"}
                        onClick={onFindClick}
                    >
                        {t("home.findSupport")}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default NeedSupportBox;
